/**
 * Created by mslobozeanu on 6/19/2015.
 */

TS.ns('TS.domain.properties');

/**
 * @class TS.domain.properties.ListField
 * @classdesc
 * @extends TS.Observable
 * @ignore
 */
var ListField = TS.domain.properties.ListField = new Class(
	/** @lends TS.domain.properties.ListField# */
	{

		Extends: TS.Observable,

		mapping: {
			ignore: [],
			copy: ['type', 'Name', 'ReadOnly', 'Width', 'EditorNameProperty', 'IsDynamicEditor', 'IsDynamicColumn', 'MaxLength',
				'format', 'decimalPrecision', 'useThousandSeparator'
			],
			suppress: ['type', 'Name', 'ReadOnly', 'Width', 'Visible', 'Title', 'Frozen', 'EditorNameProperty', 'IsDynamicEditor', 'IsDynamicColumn', 'MaxLength', 'AllowResize', 'AllowSort', 'AllowFilter',
				'format', 'decimalPrecision', 'useThousandSeparator'
			]
		},

		/**
		 * Property Name. Should be unique in the context of a binding list property.
		 * @member {String}
		 */
		Name: null,

		Width: 100,

		observables: {
			PropertyName: undefined,
			Title: '',
			Visible: true,
			Frozen: false,
			AllowSort: true,
			AllowResize: true,
			AllowFilter: false,

			Format: undefined
		},

		initialize: function (owner, config) {
			this[TS.Constants.ownerProp] = owner;

			var me = this;
			me.config = config;
			Object.append(me, ko.mapping.fromJS(config, this.getMappingOptions()));

			me.parent();
		},

		getMappingOptions: function () {
			return this.mapping;
		},

		Domain: function () {
			return this._getOwner().Domain();
		},

		/**
		 * Gets a reference to the view model that owns this property.
		 * @returns {Object}
		 * @public
		 */
		_getOwner: function () {
			return this[TS.Constants.ownerProp];
		},

		getEditorType: function () {
			var type = this.type != null ? this.type : "";
			type === 'defaultType'&& (type = 'text');
			return type || "text";
		},

		getEditor: function (editorName) {
			var me = this,
				bindingListProperty =  me._getOwner(),
				result;
			$.each(bindingListProperty.Fields(), function(index, field){
				if(field.IsDynamicEditor && field.Name === editorName){
					result = field;
					return false;
				}
			});
			return result;
		},

		Value: function (value) {
			var me = this,
				bindingListProperty = me._getOwner();
			if(arguments.length === 0) {
				if (bindingListProperty && bindingListProperty.SelectedItem()) {
					return TS.unwrap(bindingListProperty.SelectedItem()[me.PropertyName()]);
				}
				return null;
			}
			if (bindingListProperty && bindingListProperty.SelectedItem()) {
				ts.setPropertyValue(bindingListProperty.SelectedItem(), me.PropertyName(), value);
			}
		}
	});


var types = ListField.types = {};

ListField.create = function(owner, config){
	var listFieldType = types[config.type];
	if(listFieldType){
		return new listFieldType(owner, config);
	}
	return new ListField(owner, config);
};